import { Icon, makeStyles, Text, useTheme } from '@rneui/themed'
import React from 'react'
import { View } from 'react-native'
import { CheckBox } from 'shared/components/check_box'
import { PressableOpacity } from 'shared/components/pressable_opacity'

interface Props {
  title: string
  isCollapsed: boolean | undefined
  onToggleCollapse: () => void
  showCheckbox?: boolean
  isChecked?: boolean
  onCheckboxPress?: () => void
}

export function CollapsibleSectionHeader({
  title,
  isCollapsed,
  onToggleCollapse,
  showCheckbox = false,
  isChecked = false,
  onCheckboxPress,
}: Props) {
  const styles = useStyles()
  const { theme } = useTheme()
  const chevronColor = theme.colors.white
  return (
    <View style={styles.headerWithActions}>
      <PressableOpacity style={styles.headerContent} onPress={onToggleCollapse}>
        <View style={styles.titleRow}>
          {!isChecked && (
            <Icon
              name={isCollapsed ? 'chevron-right' : 'chevron-down'}
              type="feather"
              size={16}
              color={chevronColor}
              style={styles.chevronIcon}
            />
          )}
          <Text style={styles.sectionHeaderText}>{title}</Text>
        </View>
        {showCheckbox && (
          <View style={styles.sectionHeaderActions}>
            <CheckBox checked={isChecked} onPress={onCheckboxPress} />
          </View>
        )}
      </PressableOpacity>
    </View>
  )
}

const useStyles = makeStyles(theme => ({
  headerSimple: {
    backgroundColor: theme.colors?.grey2,
    paddingHorizontal: 16,
    paddingTop: 6,
    marginBottom: 10,
    height: 30,
  },
  headerWithActions: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    backgroundColor: theme.colors?.grey2,
    paddingHorizontal: 16,
    marginBottom: 10,
    alignItems: 'center',
    height: 50,
  },
  headerContent: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    flex: 1,
  },
  titleRow: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  sectionHeaderActions: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  sectionHeaderText: {
    color: theme.colors?.white,
    fontSize: 14,
  },
  chevronIcon: {
    marginRight: 8,
  },
}))
